<template>
  <shared-provide-variation :variation="variation" :fromModule="fromModule" :toModule="toModule" @change="emitToParent">

    <div class="divider"><span>Atributos</span></div>

    <div class="l-row">
      <form-group label="Gênero" :columns="3" :error="getError('gender', variation.sku)" :required="true">
        <select v-model="variation.gender" class="form-select" :disabled="disabledInputs()">
          <option value="male">
            {{ $t('netshoes.gender.male.label') }}
          </option>
          <option value="female">
            {{ $t('netshoes.gender.female.label') }}
          </option>
          <option value="unisex">
            {{ $t('netshoes.gender.unisex.label') }}
          </option>
        </select>
      </form-group>

      <form-group v-if="Object.keys(variation.attributes).indexOf('color') !== -1" :label="$t(`color.label`)" :columns="3" :error="getError('color', variation.sku)" :required="true">
        <select v-model="variation.attributes['color']" v-html="options('color')" class="form-select" :disabled="disabledInputs()"></select>
      </form-group>

      <form-group v-if="Object.keys(variation.attributes).indexOf('flavor') !== -1" :label="$t(`flavor.label`)" :columns="3" :error="getError('flavor', variation.sku)" :required="true">
        <select v-model="variation.attributes['flavor']" v-html="options('flavor')" class="form-select" :disabled="disabledInputs()"></select>
      </form-group>

      <form-group v-if="Object.keys(variation.attributes).indexOf('size') !== -1" :label="$t(`size.label`)" :columns="3" :error="getError('size', variation.sku)" :required="true">
        <select v-model="variation.attributes['size']" v-html="options('size')" class="form-select" :disabled="disabledInputs()"></select>
      </form-group>
    </div>
  </shared-provide-variation>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import SharedProvideVariation from '@/components/marketplace/shared/provide/Variation'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    props: {
      variation: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    async mounted () {
      if (!this.getSizes().length) {
        await this.fetchSizes()
      }

      if (!this.getFlavors().length) {
        await this.fetchFlavors()
      }

      if (!this.getColors().length) {
        await this.fetchColors()
      }

      if (this.variation.attributes['size'] !== undefined && this.getSizes().indexOf(this.variation.attributes.size) === -1) {
        this.variation.attributes.size = 'Único'
      }

      if (this.variation.attributes['flavor'] !== undefined && this.getFlavors().indexOf(this.variation.attributes.flavor) === -1) {
        this.variation.attributes.flavor = 'Sem Sabor'
      }

      const presetColor = this.$parent.$parent.$parent.getPresetItemByTypeAndFrom('color', { color: this.variation.attributes.color })
      if (presetColor !== null && presetColor !== undefined) {
        this.variation.attributes.color = presetColor.color
      }

      if (this.variation.attributes.color) {
        this.variation.attributes.color = this.variation.attributes.color.replace('/', '+')
        if (!this.getColors().some(color => color.toLowerCase() === this.variation.attributes.color.toLowerCase())) {
          this.variation.attributes.color = ''
        } else {
          this.variation.attributes.color = this.getColors().find(color => color.toLowerCase() === this.variation.attributes.color.toLowerCase())
        }
      }

      const presetSize = this.$parent.$parent.$parent.getPresetItemByTypeAndFrom('size', { size: this.variation.attributes.size })
      if (presetSize !== null && presetSize !== undefined) {
        this.variation.attributes.size = presetSize.size
      }
    },
    methods: {
      ...mapActions('sizes', [
        'fetchSizes'
      ]),
      ...mapActions('flavors', [
        'fetchFlavors'
      ]),
      ...mapActions('colors', [
        'fetchColors'
      ]),
      disabledInputs () {
        return this.variation.status === 'sent' || this.variation.status === 'error'
      },
      options (attribute) {
        let options = ''

        if (attribute === 'size') {
          options += this.getSizes()
            .map(size => `<option value="${size}">${size}</option>`)
            .join(`\n`)
        } else if (attribute === 'color') {
          options += this.getColors()
            .map(color => `<option value="${color}">${color}</option>`)
            .join(`\n`)
        } else if (attribute === 'flavor') {
          options += this.getFlavors()
            .map(flavor => `<option value="${flavor}">${flavor}</option>`)
            .join(`\n`)
        }

        return '<option value="">Selecione</option>' + options
      },
      emitToParent (value) {
        this.$emit('change', value)
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ]),
      ...mapGetters('sizes', [
        'getSizes'
      ]),
      ...mapGetters('flavors', [
        'getFlavors'
      ]),
      ...mapGetters('colors', [
        'getColors'
      ])
    },
    components: {
      SharedProvideVariation,
      FormGroup
    }
  }
</script>



// WEBPACK FOOTER //
// Variation.vue?58ac2b2a